// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".time-interval-inputs[data-v-23f23580]{display:flex;gap:12px}", "",{"version":3,"sources":["webpack://./resources/js/modals/ExportModal.vue"],"names":[],"mappings":"AACA,uCACI,YAAA,CACA,QAAJ","sourcesContent":["\n.time-interval-inputs {\n    display: flex;\n    gap: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
